import React from 'react';
import { Star, Heart } from 'lucide-react';

interface HigherPowerCardProps {
  name: string;
  message?: string;
  emoji: string;
  onConnect: () => void;
}

export default function HigherPowerCard({ name, message, emoji, onConnect }: HigherPowerCardProps) {
  return (
    <div 
      className="relative bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl p-6 
        border-2 border-amber-200 hover:border-amber-300 transition-all cursor-pointer
        hover:shadow-lg hover:shadow-amber-100/50 group"
      onClick={onConnect}
    >
      <div className="flex items-center space-x-4">
        <button
          className="p-3 bg-gradient-to-br from-amber-400 to-amber-500 rounded-lg
            shadow-lg shadow-amber-200/50 group-hover:shadow-amber-300/50 transition-all
            group-hover:scale-105 relative"
        >
          <span className="text-2xl">{emoji}</span>
        </button>
        <div>
          <h3 className="text-lg font-semibold text-amber-800 group-hover:text-amber-700 transition-colors">
            {name}
          </h3>
          <div className="flex items-center space-x-2 text-sm text-amber-600">
            <Heart className="h-4 w-4 group-hover:text-amber-500 transition-colors" />
            <span>Higher Power</span>
          </div>
        </div>
      </div>

      {/* Quick Access Guidance */}
      <div className="mt-4 space-y-2">
        {message && (
          <p className="text-amber-700 group-hover:text-amber-600 transition-colors">
            {message}
          </p>
        )}
        <div className="flex items-center justify-end space-x-2 text-sm">
          <button 
            className="px-3 py-1.5 text-amber-600 hover:text-amber-500 
              hover:bg-amber-50 rounded-lg transition-colors"
          >
            Connect
          </button>
        </div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute -top-1 -right-1 w-20 h-20 bg-gradient-to-br from-amber-200/20 to-transparent rounded-tr-xl opacity-0 group-hover:opacity-100 transition-opacity" />
      <div className="absolute -bottom-1 -left-1 w-20 h-20 bg-gradient-to-tl from-amber-200/20 to-transparent rounded-bl-xl opacity-0 group-hover:opacity-100 transition-opacity" />
    </div>
  );
}